export const ranks = [
  'Unranked',
  'Iron',
  'Bronze',
  'Silver',
  'Gold',
  'Platinum',
  'Diamond',
  'Master',
  'Grand Master',
  'Challenger'
];

export const regions = {
  'NA': 'North America',
  'EUW': 'Europe West',
  'EUNE': 'Europe Nordic & East',
  'OCE': 'Oceania',
  'BR': 'Brazil',
  'LAN': 'Latin America North',
  'LAS': 'Latin America South',
  'RU': 'Russia',
  'TR': 'Turkey',
  'JP': 'Japan',
  'PBE': 'Public Beta Environment'
};

export const valorantRanks = [
  'Unranked',
  'Radiant',
  'Immortal',
  'Ascendant',
  'Diamond',
  'Platinum',
  'Gold',
  'Silver',
  'Bronze',
  'Iron',
];
